// Angular
import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

// Components
import { ConnectionStatusDialogComponent } from './dialogs/connection-status-dialog/connection-status-dialog.component';

// Models
import { AppCleanup } from '../../models';

// Services
import { SyncService, UtilityService } from '../../services';

@Component({
	selector: 'online-indicator',
	templateUrl: './online-indicator.component.html',
	styleUrls: ['./online-indicator.component.scss'],
})
export class OnlineIndicatorComponent extends AppCleanup implements OnInit, OnDestroy {
	@Input() showText: boolean = true;
	hideTooltip: boolean = true;

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.hideTooltip = window.innerWidth > 1025;
	}

	constructor(
		public syncService: SyncService,
		private dialog: MatDialog,
		private utilityService: UtilityService
	) {
		super();
	}

	ngOnInit() {
		this.utilityService.simulateWindowResize();
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	openConnectionStatus() {
		const dialogRef = this.dialog.open(ConnectionStatusDialogComponent, {
			width: '100%',
			maxWidth: '550px',
			autoFocus: false,
		});
	}
}
